module.exports = __webpack_public_path__ + "static/media/wonderful_answer_no_content.7cd81624.png";